import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import { AuthProvider } from './contexts/AuthContext.tsx'
import './index.css'

// 2026-06-11 (86ca7n8d4): the SmartLead two-way mailbox sync is NO LONGER
// auto-started here. This ran for EVERY session — including client users —
// 30s after any page load: each client browser fetched the entire
// cross-client mailbox fleet from SmartLead, detected "conflicts" against
// other clients' mailboxes, batch-WROTE updates back to SmartLead, and
// spammed failing discrepancy-record inserts (blocked by RLS for the
// client role), repeatedly freezing the tab. The scheduler now starts
// only on the admin-only Domains & Mailboxes page
// (DomainsAndMailboxDashboard), where its status panel and manual
// controls live. Canonical mailbox state is owned by the
// daily-mailbox-status-sync edge function (6 AM UTC cron).

// 2026-10-26: after a deploy, a tab still running the old build asks for page files
// the server no longer has (404) and the page goes blank. Vite fires
// vite:preloadError when that happens: reload once to pick up the new build.
// The timestamp guard stops a reload loop if the file is genuinely missing.
window.addEventListener('vite:preloadError', (event) => {
  try {
    const last = Number(sessionStorage.getItem('ob-stale-reload-at') || 0)
    if (Date.now() - last < 60_000) return
    sessionStorage.setItem('ob-stale-reload-at', String(Date.now()))
  } catch { /* storage blocked: still reload once */ }
  event.preventDefault()
  window.location.reload()
})

createRoot(document.getElementById("root")!).render(
  <AuthProvider>
    <App />
  </AuthProvider>
);
